export default __webpack_public_path__ + "static/media/it.febcc1b1.svg";